import RequiredDistributionsPage from '@playground/features/dictionary/RequiredDistributionsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/required-distributions'
)({
  component: RequiredDistributionsPage,
})
